import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

import { transition } from "../../utils/transition";

export const activeOptionStyle = recipe({
  base: {
    display: "flex",
    alignItems: "center",
    gap: rem(8),
    userSelect: "none",
    overflow: "hidden",
  },
  variants: {},
});

export const iconStyle = recipe({
  base: {
    transition: transition("transform"),
  },
  variants: {
    isOpen: {
      true: {
        transform: "rotate(-180deg)",
      },
    },
  },
});
